
































































import { Component, Mixins } from "vue-property-decorator";
import { qrcanvas } from "qrcanvas";
import html2canvas from "html2canvas";
import { DetailMixins } from "./detailMixins";
@Component
export default class CaseDetail extends Mixins(DetailMixins) {
  public likeImage = require("@/assets/images/case/like.png");
  public likedImage = require("@/assets/images/case/liked.png");
  public loading = false;
  public visible = false;
  public imgUrl = "";
  // 分享
  handleShare() {
    this.visible = true;
    if (this.imgUrl) return;
    this.loading = true;
    this.$nextTick(() => {
      const canvas1 = qrcanvas({
        data: decodeURIComponent(`${this.baseUrl}/#/h5/${this.id}`),
        size: 125
      });
      const opts = {
        scale: 2,
        dpi: 192,
        scrollX: -5,
        scrollY: 0,
        useCORS: true
      };
      (document.getElementById("qrCode") as any).appendChild(canvas1);
      //合成分享图
      setTimeout(() => {
        html2canvas(document.querySelector("#qrBox") as HTMLElement, opts)
          .then(canvas => {
            this.imgUrl = canvas.toDataURL("image/png");
          })
          .finally(() => (this.loading = false));
      }, 1000);
    });
  }
  loadPdfHandler(){
    sessionStorage.setItem("loaded", "1");
    const timer = setTimeout(() => {
      sessionStorage.removeItem("loaded")
    }, 3000);
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    })
  }
  // 复制图片
  handleCopy() {
    const a = document.createElement("a");
    const event = new MouseEvent("click");
    a.download = name || "2021病案年会";
    a.href = this.imgUrl;
    a.dispatchEvent(event);
  }
  async mounted() {
    this.getInfo();
  }
}
